enum WorkspaceProjectMetricMeasurementInterval {
  'Continuous' = 'Continuous',
  'Fixed intervals' = 'Fixed intervals',
}

export default WorkspaceProjectMetricMeasurementInterval
